module.exports = __webpack_public_path__ + "media/arrow_orange.0a7c78eb.svg";